import { gql, QueryHookOptions, useQuery } from '@apollo/client';
import {
  GQLQueryJob_GetAllJobSummariesArgs,
  GQLJobSummaryConnection,
  GQLJobSummary,
  GQLQueryJob_GetJobArgs,
  GQLJob
} from '@jewelutions/core-crm-server-api-client-domain';
import { JOB_FIELDS, JOB_SUMMARY_FIELDS } from './fragments/job';
import { OperationsHelper } from './OperationHelper';
import { Exception } from '@jewelutions/core-common-domain';
export class JobOperation {
  jobSummaryArrayFromResponse(data: any): GQLJobSummary[] {
    if (data.Job_getAllJobSummaries !== undefined) {
      return data.Job_getAllJobSummaries.jobSummaries;
    }

    return OperationsHelper.retrievePropertyFromGQLResponse(data, 'jobSummaries');
  }

  jobFromResponse(data: any): GQLJob {
    if (data.Job_getJob !== undefined) {
      return data.Job_getJob;
    }
    throw new Exception(`Cannot handle input data pieceAsset`);
  }

  getJob(args: GQLQueryJob_GetJobArgs, options: QueryHookOptions<GQLJob, GQLQueryJob_GetJobArgs> = {}) {
    const query = gql`
      ${JOB_FIELDS}
      query Job_getJob($jobId: ID!) {
        Job_getJob(jobId: $jobId) {
          ...JobFields
        }
      }
    `;

    return useQuery<GQLJob, GQLQueryJob_GetJobArgs>(query, {
      ...options,
      variables: args
    });
  }

  getAllJobSummaries(
    args: GQLQueryJob_GetAllJobSummariesArgs,
    options: QueryHookOptions<GQLJobSummaryConnection, GQLQueryJob_GetAllJobSummariesArgs> = {}
  ) {
    const query = gql`
      ${JOB_SUMMARY_FIELDS}
      query Job_getAllJobSummaries($pageSize: Int = 10) {
        Job_getAllJobSummaries(pageSize: $pageSize) {
          cursor
          hasMore
          jobSummaries {
            ...JobSummaryFields
          }
        }
      }
    `;

    return useQuery<GQLJobSummaryConnection, GQLQueryJob_GetAllJobSummariesArgs>(query, {
      ...options,
      variables: args
    });
  }
}
